"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var roadmaps_html_1 = __importDefault(require("./roadmaps.html"));
var roadmaps_controller_1 = __importDefault(require("./roadmaps.controller"));
var RoadmapsList_directive_1 = __importDefault(require("./RoadmapsList.directive"));
var RoadmapEditor_directive_1 = __importDefault(require("./RoadmapEditor.directive"));
var create_roadmap_module_1 = __importDefault(require("./create-roadmap/create-roadmap.module"));
var edit_roadmap_module_1 = __importDefault(require("./edit-roadmap/edit-roadmap.module"));
function config($stateProvider, $urlRouterProvider) {
    // The list lives in an index child state rather than as ui-view fallback
    // content. ngVue components inside ui-view fallback content get re-linked
    // and orphaned when a child state takes over the view.
    $stateProvider.state("drivecoach.admin.roadmaps", {
        url: "/roadmaps",
        abstract: true,
        template: "<section ui-view></section>",
    });
    $stateProvider.state("drivecoach.admin.roadmaps.index", {
        url: "",
        controller: "RoadmapsController",
        controllerAs: "vm",
        template: roadmaps_html_1.default,
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider"];
exports.default = angular_1.default
    .module("drivecoach.admin.roadmaps", [
    RoadmapsList_directive_1.default.name,
    RoadmapEditor_directive_1.default.name,
    create_roadmap_module_1.default.name,
    edit_roadmap_module_1.default.name,
])
    .config(config)
    .controller("RoadmapsController", roadmaps_controller_1.default);
